import { Injectable } from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {AppCommunicationService} from '../services/app-communication.service';
import {UserRolePipe} from '../pipes/user-role.pipe';

@Injectable()
export class RoleGuard implements CanActivate {

    constructor(
        private _appCommunicationService: AppCommunicationService,
        private _userRolePipe: UserRolePipe
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        const roles = route.data['roles'] as Array<string>;
        return (roles.some(role => this._userRolePipe.transform([role])))
    }
}



// WEBPACK FOOTER //
// ./src/app/+app-custom/guards/role.guard.ts